import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { resizeObservable } from '@df/dom/fn/resize-observable';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { VisibilityService } from '@df/ui/common/visibility.service';
import { Subscription } from 'rxjs';
import { StickyFreeService } from '../sticky-free/sticky-free.service';
import { ScrollNavScope } from './scroll-nav-scope';

@Directive({
    selector: '[scrollNavTarget]',
    standalone: true
})
export class ScrollNavTargetDirective implements OnInit, OnDestroy {
    @Input()
    scrollNavTarget!: string;

    @Output()
    scrollNavScrollTo = new EventEmitter<void>();

    private subscriptions = new Subscription();

    constructor(
        private elementRef: ElementRef,
        private visibilityService: VisibilityService,
        private stickyFreeService: StickyFreeService,
        private scrollToService: ScrollToService,
        @Optional() private scrollNavScope: ScrollNavScope
    ) {}

    ngOnInit() {
        if (!this.scrollNavScope) {
            return;
        }
        this.subscriptions.add(
            resizeObservable(this.elementRef.nativeElement, entry => {
                if (entry.contentRect.height) {
                    this.scrollNavScope.register(this);
                } else {
                    this.scrollNavScope.unregister(this);
                }
            }).subscribe()
        );

        this.subscriptions.add(
            this.visibilityService
                .isInView(this.elementRef, {
                    rootMargin: `-60px 0px 0px 0px`
                })
                .subscribe(value => {
                    this.scrollNavScope.visibilityChange(this, value);
                })
        );
    }

    ngOnDestroy() {
        this.scrollNavScope?.unregister(this);
    }

    scrollTo() {
        this.scrollNavScrollTo.emit();
        this.scrollToService.scrollTo(this.elementRef.nativeElement, {
            offset: this.stickyFreeService.getStickyHeight() + 20
        });
    }

    getTopPosition() {
        return this.elementRef.nativeElement.getBoundingClientRect().top;
    }
}
